import { render, staticRenderFns } from "./BICOnusForm.vue?vue&type=template&id=6a624c73&"
import script from "./BICOnusForm.vue?vue&type=script&lang=js&"
export * from "./BICOnusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a624c73')) {
      api.createRecord('6a624c73', component.options)
    } else {
      api.reload('6a624c73', component.options)
    }
    module.hot.accept("./BICOnusForm.vue?vue&type=template&id=6a624c73&", function () {
      api.rerender('6a624c73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/biconus/BICOnusForm.vue"
export default component.exports